import React, { Fragment, useEffect } from "react";

import background from "@common/assets/images/empty-state/release-module-empty-heading.png";
import HouseIcon from "@common/assets/images/FTUX/help-icon.svg";
import { HelperText } from "@common/components/HelperText/HelperText";
import displayToast from "@common/components/Toast/displayToast";
import Toast from "@common/components/Toast/Toast";
import { useAppSelectionContext } from "@main/context/App/AppSelectionContext";
import { ReleasesModuleDescriptionBox } from "@main/pages/shared/components/ModuleDescriptionBox/ModuleDescriptionBox";
import { RoutePaths } from "@main/router/config/routePaths";
import { generatePath, useNavigate } from "react-router-dom";

import * as Styled from "./ModuleEmptyState.styles";

const RELEASES_SOMETHING_NOT_WORKING_TOAST = "releases-something-not-working";

export const ReleasesModuleEmptyState = () => {
  const { selectedWorkspace } = useAppSelectionContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (!selectedWorkspace) return;
    displayToast({
      icon: HouseIcon,
      containerId: RELEASES_SOMETHING_NOT_WORKING_TOAST,
      title: "Questions while setting up?",
      content: (
        <Fragment>
          {"Ask AI, dig into the docs, or chat with our engineers. "}
          {
            <Styled.StyledLink
              onClick={() => navigate(generatePath(RoutePaths.QUICK_LINKS, { workspaceSlug: selectedWorkspace.slug }))}
            >
              Get help →
            </Styled.StyledLink>
          }
        </Fragment>
      ),
    });
  }, [navigate, selectedWorkspace]);

  return (
    <Styled.BackgroundContainer style={{ backgroundImage: `url("${background}")` }}>
      <Styled.Container>
        <Styled.HeadingBoxWrapper>
          <ReleasesModuleDescriptionBox />
        </Styled.HeadingBoxWrapper>
        <HelperText>{"Release scores start calculating once your first sessions arrives."}</HelperText>
      </Styled.Container>
      <Toast
        containerId={RELEASES_SOMETHING_NOT_WORKING_TOAST}
        autoClose={false}
      />
    </Styled.BackgroundContainer>
  );
};
